export default "__VITE_ASSET__Ddi7hUY___"